import { BlueprintsStore } from "imagica-corekit/dist/base/store/BlueprintsStore";
import { Container } from "inversify";
import { FotAuthStore } from "imagica-corekit/dist/base/store/FotAuthStore";
import { FotClient } from "imagica-corekit/dist/base/api/FotClient";
import { PersonalFunctionStore } from "imagica-corekit/dist/base/store/PersonalFunctionStore";
import { AuthStore } from "imagica-corekit/dist/base/store/AuthStore";
import { ProjectStore } from "imagica-corekit/dist/base/store/ProjectStore";
import { CookieStorageManagerImpl } from "@infra/CookieStorageManagerImpl";
import { FunctionV2Store } from "imagica-corekit/dist/base/store/FunctionV2Store";
import { UiFunctionService } from "@uikit/service/UiFunctionService";
import { CorekitRegistry, CorekitRegistryParams } from "imagica-corekit/dist/registry/CorekitRegistry";
import { ServiceIdentifier } from "imagica-corekit/dist/base/cutil/ServiceIdentifier";
import { ToolPieceStore } from "imagica-corekit/dist/base/store/ToolPieceStore";
import { LocalStorageManagerImpl } from "imagica-corekit/dist/infra/LocalStorageManagerImpl";
import { LocationManagerImpl } from "imagica-corekit/dist/infra/LocationManagerImpl";
import { ChatAIStore } from "@uiview/views/ChatAI/ChatAIStore";
import { HomePluginStore } from "imagica-corekit/dist/base/store/HomePluginStore";
import { PreviewPaneStore } from "@uiview/views/PreviewPane/PreviewPaneStore";
import { HomeStore } from "imagica-corekit/dist/cases/store/HomeStore";
import { ProjectNetDataStore } from "@base/ProjectNetDataStore";
import { MeStore } from "imagica-corekit/dist/base/store/MeStore";

export class InjectConfig {
  private static container?: Container;

  static get<T>(serviceIdentifier: ServiceIdentifier<T>): T {
    return InjectConfig.configure().get<T>(serviceIdentifier);
  }

  private static configure(): Container {
    if (InjectConfig.container != null) {
      return InjectConfig.container;
    }
    const container = new Container({
      autoBindInjectable: true,
      defaultScope: "Singleton",
      skipBaseClassChecks: true,
    });
    InjectConfig.container = container;

    const params: CorekitRegistryParams = {
      cookieStorageManager: new CookieStorageManagerImpl(),
      defaultStorageManager: new LocalStorageManagerImpl(),
      locationManager: new LocationManagerImpl(),
    };
    CorekitRegistry.configure(container, params);
    InjectConfig.after(container, params);

    console.log("InjectConfig complete");
    return container;
  }

  private static after(container: Container, params: CorekitRegistryParams) {
    const it = <T>(serviceIdentifier: ServiceIdentifier<T>): T => {
      return container.get(serviceIdentifier);
    };
    const chatAIStore = new ChatAIStore();
    const homePluginStore = new HomePluginStore();
    const projectDataStore = new ProjectNetDataStore(it(MeStore));

    const fotHomeStore = new HomeStore();
    const previewPaneStore = new PreviewPaneStore();
    container.bind(ChatAIStore).toConstantValue(chatAIStore);
    container.bind(HomePluginStore).toConstantValue(homePluginStore);
    container.bind(HomeStore).toConstantValue(fotHomeStore);
    container.bind(PreviewPaneStore).toConstantValue(previewPaneStore);
    container.bind(ProjectNetDataStore).toConstantValue(projectDataStore);
    container
      .bind(UiFunctionService)
      .toConstantValue(
        new UiFunctionService(it(FunctionV2Store), it(PersonalFunctionStore), it(ToolPieceStore), it(BlueprintsStore))
      );
  }
}
